import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
// import { render } from "react-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const isLaunchExperience = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname.toLowerCase();
  const params = new URLSearchParams(window.location.search);
  const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
  return hostname === 'launch.palau.ocean-portal.org'
    || pathname === '/launch'
    || params.get('launch') === 'ceremony';
};

const getLaunchPortal = () => {
  if (typeof window === 'undefined') return 'palau';
  const hostname = window.location.hostname.toLowerCase();
  const params = new URLSearchParams(window.location.search);
  return hostname === 'rmi.ocean-portal.org' || params.get('portal') === 'rmi'
    ? 'rmi'
    : 'palau';
};

const LaunchExperience = lazy(() => import('./launch/LaunchPage'));
const launchExperience = isLaunchExperience();
const launchPortal = getLaunchPortal();

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

document.title = launchExperience
  ? (launchPortal === 'rmi' ? 'Beta Launch | Marshall Islands Ocean Portal' : 'Official Launch | Palau Ocean Portal')
  : 'Palau Ocean Portal';

// Inject global styles for the "Glass" background base
const style = document.createElement('style');
style.innerHTML = `
  body {
    transition: background 0.5s ease, color 0.5s ease;
    background-attachment: fixed;
    min-height: 100vh;
  }
  body.light {
    background: linear-gradient(to bottom right, #1e3a8a, #1e40af, #172554); /* Navy Blue (Blue 900 - Blue 800 - Blue 950) */
    color: #f8fafc;
  }
`;
document.head.appendChild(style);

root.render(
  // <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {launchExperience ? (
        <Suspense fallback={<div className="min-h-[100dvh] bg-[#03162b]" aria-label="Loading" />}>
          <LaunchExperience portal={launchPortal} />
        </Suspense>
      ) : <App />}
    </QueryClientProvider>
  // </React.StrictMode>
);
